import { render, staticRenderFns } from "./TSPItem.vue?vue&type=template&id=f18eca64&scoped=true"
import script from "./TSPItem.vue?vue&type=script&lang=js"
export * from "./TSPItem.vue?vue&type=script&lang=js"
import style0 from "./TSPItem.vue?vue&type=style&index=0&id=f18eca64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18eca64",
  null
  
)

export default component.exports